// 班级接口
export default function (axios) {
  return {
    // 班级-增/改
    pxb_addApi(params) {
      return axios.post("/cultivate/trainingClass/editTrainingClass", params);
    },
    // 班级-删除
    pxb_delApi(params) {
      return axios.get("/cultivate/trainingClass/deleteTrainClass", { params });
    },
    // 班级-查列表
    pxb_ListApi(params) {
      return axios.post("/cultivate/trainingClass/selectPage", params);
    },
    // 班级-查详情
    pxb_detailApi(params, nose) {
      return axios.get(
        "/cultivate/trainingClass/selectById" + (nose ? "Nose" : ""),
        { params }
      );
    },
    // 报名
    pxb_appendApi(params) {
      return axios.post("/cultivate/trainingClass/enrollClass", params);
    },
    // 报名审批
    pxb_approveAppendApi(params) {
      return axios.post("/cultivate/trainingClass/auditClassTrainee", params);
    },
    // 班级-上下线
    pxb_onlineApi(params) {
      return axios.post(
        "/cultivate/trainingClass/updateOnline",
        {},
        { params }
      );
    },
    // 班级-详情栏目名称数据统计
    pxb_selectClassSummaryApi(params) {
      return axios.get("/cultivate/trainingClass/selectClassSummary", {
        params,
      });
    },
    // 班级-是否收藏
    pxb_selectCollect(params) {
      return axios.get("/cultivate/trainingClass/selectCollect", {
        params,
      });
    },

    // *****************************************************
    // 班级-课程
    // *****************************************************
    // 课程-新增
    pxbkc_addApi(params) {
      return axios.post("/cultivate/classCourse/addClassCourse", params);
    },
    // 课程-删除
    pxbkc_delApi(params) {
      return axios.get("/cultivate/classCourse/deleteClassCourse", { params });
    },
    // 课程-列表
    pxbkc_listApi(params, nose) {
      return axios.post(
        "/cultivate/classCourse/selectPage" + (nose ? "Nose" : ""),
        params
      );
    },
    // 课程-设置必修、选修
    pxbkc_updateTypeApi(params) {
      return axios.post(
        "/cultivate/classCourse/updateCourseType",
        {},
        { params }
      );
    },
    // 课程-列表-筛选条件“讲师”列表
    pxbkc_lecturerListApi(params) {
      return axios.get("/cultivate/classCourse/selectLecturer", { params });
    },
    // *****************************************************
    // 班级-学员
    // *****************************************************
    // 学员-增/改
    pxbxy_addApi(params, fx) {
      let add = "/cultivate/classTrainee/addClassTrainee";
      let edit = "/cultivate/classTrainee/updateClassTrainee";
      let url = params?.traineeId ? edit : add;
      if (fx == "add") {
        url = add;
      }
      return axios.post(url, params);
    },
    // 学员-删
    pxbxy_delApi(params) {
      return axios.get("/cultivate/classTrainee/deleteTrainee", { params });
    },
    // 学员-查-列表
    pxbxy_listApi(params) {
      return axios.post("/cultivate/classTrainee/selectPage", params);
    },

    // *****************************************************
    // 班级-讲师
    // *****************************************************
    // 讲师-增/改
    // pxbjs_addApi(params) {
    //   let add = "/cultivate/classLecture/addLecturer";
    //   let edit = "/cultivate/classLecture/update";
    //   let url = params?.traineeId ? edit : add;
    //   return axios.post(url, params);
    // },
    pxbjs_addApi(params) {
      let add = "/cultivate/classLecture/addLecturer";
      let url = add;
      return axios.post(url, params);
    },
    // 讲师-删
    pxbjs_delApi(params) {
      return axios.get("/cultivate/classLecture/deleteClassLecturer", {
        params,
      });
    },
    // 讲师-查-列表
    pxbjs_listApi(params) {
      return axios.post(
        "/cultivate/classLecture/selectClassLecturePage",
        params
      );
    },
    // 讲师-查-详情
    pxbjs_detailApi(params) {
      return axios.get("/cultivate/classLecture/selectById", { params });
    },

    // *****************************************************
    // 评论
    // *****************************************************
    // 评论-新增/修改
    pxbpl_editApi(params) {
      return axios.post("/cultivate/classComment/editClassComment", params);
    },
    // 评论-列表
    pxbpl_listApi(params, nose) {
      return axios.post(
        "/cultivate/classComment/selectPage" + (nose ? "Nose" : ""),
        params
      );
    },
    // 评论-回复
    pxbpl_replyApi(params) {
      return axios.post("/cultivate/classComment/editCommentReply", params);
    },
    // 评论标签-新增/修改
    pxbplbq_editApi(params) {
      return axios.post("/classTags/editTags", params);
    },
    // 评论标签-列表
    pxbplbq_listApi(params, nose) {
      return axios.post(
        "/classTags/selectTagsList" + (nose ? "Nose" : ""),
        params
      );
    },
    // 评论标签-删除
    pxbplbq_delApi(params) {
      return axios.get("/classTags/deleteTags", { params });
    },

    // *****************************************************
    // 测验
    // *****************************************************
    // 测验-新增/修改
    pxbcy_editApi(params) {
      return axios.post("/cultivate/classComment/addExamForClass", params);
    },
    // 测验-列表
    pxbcy_listApi(params) {
      return axios.get("/cultivate/classComment/selectExamPage", { params });
    },
    // 测验-删除
    pxbcy_delApi(params) {
      return axios.post(
        "/cultivate/classComment/deleteExamForClass",
        {},
        { params }
      );
    },
    // 测验-查询允许添加的测验列表
    pxbcy_examApi(params) {
      return axios.get("/cultivate/classComment/selectExamForClass", {
        params,
      });
    },

    // *****************************************************
    // 班级类型
    // *****************************************************
    // 类型-增
    pxblx_addApi(params) {
      return axios.post("/classTypeCtl/addType", params);
    },
    // 类型-改/删
    pxblx_updateApi(params) {
      return axios.get("/classTypeCtl/updateType", { params });
    },
    // 类型-查
    pxblx_listApi(params) {
      return axios.get("/classTypeCtl/selectTypeByCompId", { params });
    },
  };
}
